<template>
  <div>
    <b-modal ref="AddServiceVoucherModal" v-model="showModal" size="md" centered>
      <div slot="modal-header"><strong class="text-uppercase">Create new Service Voucher</strong></div>
      <b-row>
        <b-col md="6">
          <v-input-date
            name="AddServiceVoucherModal__date"
            v-model="service.service_datetime"
            :required="true"
            :v="$v.service['service_datetime']"
            @blur="$v.service['service_datetime'].$touch()"
            @focus="$v.service['service_datetime'].$reset()"
            label="Service Date"></v-input-date>
        </b-col>
        <b-col md="6">
          <v-input-time
            name="AddServiceVoucherModal__time"
            v-model="service.service_datetime"
            :required="true"
            :v="$v.service['service_datetime']"
            @blur="$v.service['service_datetime'].$touch()"
            @focus="$v.service['service_datetime'].$reset()"
            label="Time"></v-input-time>
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <b-button type="submit" variant="success" @click="submit">
          <i class="fa fa-dot-circle-o"></i> Add
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'AddServiceVoucher',
  props: ['value'],
  data () {
    return {
      showModal: false,
      service: {
        service_datetime: null
      }
    }
  },
  methods: {
    reset () {
      this.$v.$reset()
      this.service.service_datetime = null
    },
    checkForm () {
      let valid = !this.$v.$invalid
      if (!valid) {
        this.$v.$touch()
      } else {
        this.$v.$reset()
      }
      return valid
    },
    submit () {
      if (this.checkForm()) {
        let res = this.$store.dispatch('serviceVouchers/store', this.service)
        res.then(
          (res) => {
            this.$refs.AddServiceVoucherModal.hide()
            this.$emit('serviceVouchersAdded', res.data.id)
          }
        ).catch(
          () => {
            debugger
          }
        )
      } else {
        this.$store.dispatch('app/addValidationError', 'The form needs your attention')
      }
    }
  },
  watch: {
    value (newVal) {
      this.showModal = newVal
    },
    showModal (newVal) {
      this.$emit('input', newVal)
      if (!newVal) {
        this.reset()
      }
    }
  },
  validations: {
    service: {
      service_datetime: {
        required
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/serviceVouchers/AddServiceVoucher.vue